<template>
  <div>
    <!-- 订单列表 -->
    <div class="table-list bg-white mb15 border-radius-4">
      <!-- PT201807000152 -->
      <div class="table-cont">
        <a-row class="flex table-header plr10 flex-justify">
          <!-- <div class="table-header-item c888 0" style="width:3%;">
            <a-checkbox style="padding:0;" :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange">
            </a-checkbox>
          </div> -->
          <div class="table-header-item c888 1" style="width:20%;">箱型</div>
          <div class="table-header-item c888 2" style="width:20%;">尺寸</div>
          <div class="table-header-item c888 3" style="width:40%;">文件名</div>
          <div class="table-header-item c888 4" style="width:10%;">文件</div>
        </a-row>
        <a-row v-for="(order,i) in List" :key="i" class="flex table-con tc ptb10 plr10 flex-acenter flex-justify">
          <!-- <div class="table-con-item c333 0" style="width:3%;">
            <a-checkbox style="padding:0;" :checked="order.checked" @change="onCheckItemChange(i)">
            </a-checkbox>
          </div> -->
          <div class="table-con-item c333 1" style="width:20%;">{{ order.ctntype || '  ' }}</div>
          <div class="table-con-item c333 2" style="width:20%;">{{ order.ctnsize || '  ' }}</div>
          <div class="table-con-item c333 3" style="width:40%;">{{ order.Filesname || '  ' }}</div>
          <div class="table-con-item c333 4" style="width:10%;">
            <a v-if="order.FilePath" href="javascript:;" @click="downloadItem(order)">下载</a>
            <span v-else>{{ '   ' }}</span>
          </div>
        </a-row>
        <!-- <a-row class="flex table-con tc ptb10 plr10 flex-acenter flex-justify border-t">
          <div class="table-con-item c333" style="width:8%;"></div>
          <div class="table-con-item c333 fw700" style="width:10%;">合计</div>
          <div class="table-con-item c333" style="width:11%;"></div>
          <div class="table-con-item c333" style="width:7%;"></div>
          <div class="table-con-item c333" style="width:9%;"></div>
          <div class="table-con-item c333 fw700" style="width:7%;">{{ (order.totalQty || 0).toFixed(2) }}</div>
          <div class="table-con-item c333" style="width:7%;"></div>
          <div class="table-con-item c333 fw700" style="width:9%;">{{ (order.totalBaseQty || 0).toFixed(2) }}</div>
          <div class="table-con-item c333" style="width:7%;"></div>
          <div v-if="activeMenu!=='2'" class="table-con-item c333 fw700" style="width:9%;">{{ (order.totalNetWeight || 0).toFixed(2) }}</div>
          <div class="table-con-item c333 fw700" style="width:9%;">{{ (order.totalGrossWeight || 0).toFixed(2) }}</div>
          <div v-if="showPONo" class="table-con-item c333" style="width:7%;"></div>
        </a-row> -->
      </div>
    </div>
  </div>
</template>

<script>
import { dateToString } from '@/utils/date-formatter'
import { Ellipsis } from '@/components'
export default {
  name: 'TableList',
  components: { Ellipsis },
  props: {
    dataList: {
      type: Array,
      default: () => []
    },
    showPONo: {
      type: Boolean,
      default: false
    },
    activeMenu: {
      type: String,
      default: '1'
    }
  },
  data () {
    return {
      List: this.dataList,
      checkedList: [],
      plainOptions: [],
      indeterminate: false,
      checkAll: false
    }
  },
  watch: {
    dataList (val) {
      this.List = val
    }
  },
  mounted () {
    // this.List.length = this.dataList.length
  },
  methods: {
    dateToString,
    // collapseChange (index) {
    //   this.List[index] = !this.List[index]
    //   this.List = JSON.parse(JSON.stringify(this.List))
    // },
    onChange (checkedList) {
      this.indeterminate = !!checkedList.length && checkedList.length < this.dataList.length
      this.checkAll = checkedList.length === this.dataList.length
    },
    onCheckAllChange (e) {
      Object.assign(this, {
        checkedList: e.target.checked ? this.dataList : [],
        indeterminate: false,
        checkAll: e.target.checked
      })
    },
    onCheckItemChange (i) {
      this.List[i].checked = !this.List[i].checked
      this.$nextTick(() => {
        this.List = Object.assign(this.List)
      })
    },
    downloadItem (item) {
      // const url = 'https://oss-svc.oss-cn-shanghai.aliyuncs.com/test/20201225/5927dd814eed4d39b160d8729cb978af.zip'
      const url = item.FilePath
      window.open(url, '_blank')
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../../styles/var.less';
.table-cont {
  .table-header {
    background-color: @light-blue-bg-table;
    height: 40px;
    line-height: 40px;
    .table-header-item {
      text-align: center;
      padding: 0 5px;
    }
  }
  .table-con {
    &:nth-child(odd) {
      background-color: @bg-color-gray;
    }
    .table-con-item {
      padding: 0 5px;
      text-align: center;
      word-wrap:break-word;
      line-height: 1.2;
      min-height: 20px;
    }
  }
}
.nowarp {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
